import styled from 'styled-components/macro'
import Text from 'components/shared/Text'

export const CalendarLegendText = styled(Text)`
    width: 100%;
`
